import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { t } from '@nextcloud/l10n'
import IconMagnify from 'vue-material-design-icons/Magnify.vue'
import EmptyView from '../components/EmptyView.vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'NotFoundView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(EmptyView, {
    name: _unref(t)('spreed', 'The conversation does not exist'),
    description: _unref(t)('spreed', 'Join a conversation or start a new one!')
  }, {
    icon: _withCtx(() => [
      _createVNode(IconMagnify)
    ]),
    _: 1
  }, 8, ["name", "description"]))
}
}

})